import { cn } from '@seen/ui'
import { IconFileOff } from '@tabler/icons-react'

interface DocumentPickerEmptyStateProps {
  title?: string
  description?: string
  className?: string
}

export function DocumentPickerEmptyState({
  title = 'No documents',
  description,
  className,
}: DocumentPickerEmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 p-6 text-center text-muted-foreground',
        className
      )}
    >
      <IconFileOff className="size-10 stroke-1" />
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium">{title}</p>
        {description ? <p className="text-xs">{description}</p> : null}
      </div>
    </div>
  )
}
